import { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function AuthCallbackPage() {
  const [params] = useSearchParams()
  const { token, loading, isStaff, completeSession } = useAuth()
  const urlToken = params.get('token')

  useEffect(() => {
    if (urlToken && urlToken !== token) {
      void completeSession(urlToken)
    }
  }, [urlToken, token, completeSession])

  if (loading || (urlToken && !token)) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <p className="text-sm text-zinc-500">Completing sign in…</p>
      </div>
    )
  }

  if (token && isStaff) return <Navigate to="/" replace />
  if (token && !isStaff) return <Navigate to="/login" replace state={{ denied: true }} />
  return <Navigate to="/login" replace />
}
